<template>
  <div id="infinite-scroll">
    <div v-for="(poi, index) in pois" :key="'div_' + index">
      <PoiCard :poi="poi" :imageWidth="imageWidth" :key="poi.id" />
    </div>
    <b-alert v-if="!paginationLoading && !pois.length" class="mt-1 pt-2 pb-2" show>
      Sorry. No POIs to display.
    </b-alert>
    <SpinnerDiv :display="paginationLoading" class="mt-2" />
    <b-alert v-if="!paginationLoading && paginationEnd" class="mt-1 mb-1" show>
      <template v-if="user.loggedIn">
        You reached the end. No more POIs to display.
      </template>
      <template v-else><router-link :to="{ name: 'login' }">Login</router-link> to browse more POIs.</template>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PoiCard from '@/components/PoiCard';
import SpinnerDiv from '../components/helpers/SpinnerDiv';

export default {
  name: 'InfiniteScroll',
  components: { PoiCard, SpinnerDiv },
  props: {
    imageWidth: {
      type: String,
      default: '0600',
      validator: prop => ['0600', '1200', '1900'].includes(prop),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      pois: 'poi/records',
      paginationEnd: 'poi/paginationEnd',
      paginationLoading: 'poi/paginationLoading',
      user: 'auth/user',
    }),
  },
  methods: {
    loadNextPois() {
      // source: https://alligator.io/vuejs/implementing-infinite-scroll/#implementing-the-infinite-scroll-logic
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

      if (bottomOfWindow) {
        this.$store.dispatch('poi/getPaginationPoisNext');
      }
      if (this.paginationEnd) {
        window.removeEventListener('scroll', this.loadNextPois);
      }
    },
  },
  created() {
    if (!this.paginationEnd) {
      this.$store.dispatch('poi/getPaginationPois', { loggedIn: this.user.loggedIn });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.loadNextPois);
    //const elmnt = document.getElementById('infinite-scroll');
    //elmnt.addEventListener('scroll', this.loadNextPois);
  },
  destroyed() {
    window.removeEventListener('scroll', this.loadNextPois);
  },
};
</script>

<style scoped></style>
